if (!customElements.get('wls-product-grid')) {
  class WLSProductGrid extends HTMLElement {
    constructor() {
      super();

      this.desktopBreakpoint = 1024;

      this.classes = {
        slider: 'js-wls-product-grid-slider',
        list: 'splide__list',
        item: 'splide__slide',
        dots: 'js-wls-splide-navigation-dots',
        arrowPrev: 'js-wls-splide-navigation-arrow-prev',
        arrowNext: 'js-wls-splide-navigation-arrow-next',
        navigation: 'js-wls-splide-navigation',
        isGrid: 'is-grid',
      };

      this.elements = {
        slider: this.querySelector(`.${this.classes.slider}`),
        list: this.querySelector(`.${this.classes.list}`),
        items: this.querySelectorAll(`.${this.classes.item}`),
        navigation: this.querySelector(`.${this.classes.navigation}`),
      };

      this.resizeHandler = this.handleResize.bind(this);
    }

    connectedCallback() {
      if (this.checkIfEmpty()) return;
      this.init();
      window.addEventListener('resize', this.resizeHandler);
    }

    disconnectedCallback() {
      this.destroySplide();
      window.removeEventListener('resize', this.resizeHandler);

      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
    }

    checkIfEmpty() {
      const listInner = this.elements.list;

      if (!listInner || !listInner.children.length) {
        this.style.display = 'none';
        return true;
      }

      return false;
    }

    isDesktop() {
      return window.innerWidth >= this.desktopBreakpoint;
    }

    init() {
      if (this.isDesktop()) {
        this.enableGrid();
        return;
      }

      this.enableSlider();
    }

    handleResize() {
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }

      this.resizeTimeout = setTimeout(() => {
        if (this.isDesktop()) {
          this.enableGrid();
        } else {
          this.enableSlider();
        }
      }, 300);
    }

    enableGrid() {
      this.destroySplide();

      if (this.elements.slider) {
        this.elements.slider.classList.add(this.classes.isGrid);
      }

      if (this.elements.navigation) {
        this.elements.navigation.style.display = 'none';
      }
    }

    enableSlider() {
      if (this.elements.slider) {
        this.elements.slider.classList.remove(this.classes.isGrid);
      }

      if (this.elements.items.length <= 1) {
        if (this.elements.navigation) {
          this.elements.navigation.style.display = 'none';
        }
        this.destroySplide();
        return;
      }

      if (this.elements.navigation) {
        this.elements.navigation.style.display = '';
      }

      if (!this.splide) {
        this.initializeSplide();
      }
    }

    destroySplide() {
      if (!this.splide) return;

      this.splide.destroy(true);
      this.splide = null;
    }

    initializeSplide() {
      this.prevBtn = this.querySelector(`.${this.classes.arrowPrev}`);
      this.nextBtn = this.querySelector(`.${this.classes.arrowNext}`);
      this.paginationEl = this.querySelector(`.${this.classes.dots}`);

      this.splide = new Splide(this.elements.slider, {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        gap: '16px',
        drag: true,
        arrows: false,
        pagination: false,
      });

      this.splide.on('mounted', () => {
        this.createPagination();
        this.bindArrows();
      });

      this.splide.on('move', () => {
        this.updatePagination();
      });

      this.splide.mount();
    }

    bindArrows() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.splide.go('<'));
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.splide.go('>'));
      }
    }

    createPagination() {
      if (!this.paginationEl || !this.splide) return;

      this.paginationEl.innerHTML = '';
      this.paginationDots = [];

      for (let i = 0; i < this.splide.length; i++) {
        const dot = document.createElement('button');
        dot.className = 'wls-reviews__dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);

        dot.addEventListener('click', () => {
          this.splide.go(i);
        });

        this.paginationEl.appendChild(dot);
        this.paginationDots.push(dot);
      }

      this.updatePagination();
    }

    updatePagination() {
      if (!this.paginationDots || !this.splide) return;

      this.paginationDots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === this.splide.index);
      });
    }
  }

  customElements.define('wls-product-grid', WLSProductGrid);
}
